module.exports = __webpack_public_path__ + "static/media/book-h2o-detail3.941b6ad3.jpg";